import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface JoyrideState {
  isRunning: boolean;
  stepIndex: number;
  retryTarget: string | null;
}

const initialState: JoyrideState = {
  isRunning: false,
  stepIndex: 0,
  retryTarget: null
};

export const productOnboardingSlice = createSlice({
  name: 'productOnboarding',
  initialState,
  reducers: {
    startTour: state => {
      state.isRunning = true;
      state.stepIndex = 0;
    },
    stopTour: state => {
      state.isRunning = false;
      state.stepIndex = 0;
    },
    nextStep: state => {
      state.stepIndex += 1;
    },
    prevStep: state => {
      state.stepIndex = Math.max(0, state.stepIndex - 1);
    },
    setStepIndex: (state, action: PayloadAction<number>) => {
      state.stepIndex = action.payload;
    },
    setIsRunning: (state, action: PayloadAction<boolean>) => {
      state.isRunning = action.payload;
    },
    setRetryTarget: (state, action: PayloadAction<string | null>) => {
      state.retryTarget = action.payload;
    }
  },
  selectors: {
    getTourState: state => state
  }
});

export const {
  startTour,
  stopTour,
  nextStep,
  prevStep,
  setStepIndex,
  setIsRunning,
  setRetryTarget
} = productOnboardingSlice.actions;

export const { getTourState } = productOnboardingSlice.selectors;
